import axios from "axios";
import { del, get, post, patch,  put } from "./exam_room_assignments_api_helper";
import * as url from "./exam_room_assignments_url_helper";



export const getExamRoomAssignments = () => get(url.GET_EXAM_ROOM_ASSIGNMENTS);

export const addNewExamRoomAssignment = (examRoomAssignment) => post(url.ADD_NEW_EXAM_ROOM_ASSIGNMENT, examRoomAssignment);

export const updateExamRoomAssignment = (examRoomAssignment) => patch(`${url.UPDATE_EXAM_ROOM_ASSIGNMENT}/${examRoomAssignment.id}`,  examRoomAssignment);

export const deleteExamRoomAssignment = (examRoomAssignment) => del(`${url.DELETE_EXAM_ROOM_ASSIGNMENT}/${examRoomAssignment.id}`);



//export const getExamRoomsApi               = ()       => get(url.EXAM_ROOMS);
//export const addExamRoomApi                = (data)   => post(url.EXAM_ROOMS, data);
//export const updateExamRoomApi             = (data)   => patch(`${url.EXAM_ROOMS}/${data.uuid}`, data);
//export const deleteExamRoomApi             = (uuid)   => del(`${url.EXAM_ROOMS}/${uuid}`);

//export const getExamRoomAssignmentsApi     = ()       => get(url.EXAM_ROOM_ASSIGNMENTS);
//export const createExamRoomAssignmentApi   = (data)   => post(url.EXAM_ROOM_ASSIGNMENTS, data);

//export const generateExamRoomSeatsApi      = (uuid)   => post(`${url.EXAM_ROOM_ASSIGNMENTS}/${uuid}/generate-seats`);
//export const getExamRoomSeatsApi           = (uuid)   => get(`${url.EXAM_ROOM_ASSIGNMENTS}/${uuid}/seats`);
//export const resetExamRoomSeatsApi         = (uuid)   => del(`${url.EXAM_ROOM_ASSIGNMENTS}/${uuid}/seats`);

//export const checkExamRoomAvailabilityApi  = (data)   => post(url.CHECK_AVAILABILITY, data);

//export const getExamRoomsApi               = ()       => get(url.EXAM_ROOMS);
//export const addExamRoomApi                = (data)   => post(url.EXAM_ROOMS, data);
//export const updateExamRoomApi             = (data)   => patch(`${url.EXAM_ROOMS}/${data.uuid}`, data);
//export const deleteExamRoomApi             = (uuid)   => del(`${url.EXAM_ROOMS}/${uuid}`);

//export const getExamRoomAssignmentsApi     = ()       => get(url.EXAM_ROOM_ASSIGNMENTS);
//export const createExamRoomAssignmentApi   = (data)   => post(url.EXAM_ROOM_ASSIGNMENTS, data);

export const generateExamRoomSeats      = (uuid)   => post(`${url.EXAM_ROOM_ASSIGNMENTS}/${uuid}/generate-seats`);
export const getExamRoomSeats           = (uuid)   => get(`${url.EXAM_ROOM_ASSIGNMENTS}/${uuid}/seats`);
export const resetExamRoomSeats         = (uuid)   => del(`${url.EXAM_ROOM_ASSIGNMENTS}/${uuid}/seats`);

//export const checkExamRoomAvailability  = (data)   => post(url.CHECK_AVAILABILITY, data);



